<template>
  <GModal class="modal--discard">
    <div slot="header">
      <h2 class="modal-heading">Discard Photo</h2>
    </div>

    <div slot="body">
      <p class="text">Anda yakin ingin menghapus photo ini?</p>
    </div>

    <div slot="footer">
      <div class="group-btn">
        <div class="col-btn">
          <a href="" class="btn btn-cancel btn-minimal" @click.prevent="close">Cancel</a>
        </div>
        <div class="col-btn s">
          <a href="" class="btn btn-publish" @click.prevent="discard">Delete</a>
        </div>
      </div>
    </div>
  </GModal>
</template>

<script>
export default {
  name: 'modal-confirmation-photo',
  computed: {
    productShotKey() {
      return this.$store.state.modal.confirmationPhoto.savedKeyRemovePhoto;
    },
  },
  methods: {
    close() {
      this.$store.commit('toggleModalGlobalState', {
        modalName: 'confirmationPhoto',
      });
      this.$store.commit('setSavedKeyRemovePhoto', -1);
    },
    discard() {
      if (this.productShotKey >= 0) {
        this.$store.dispatch('removeProductShot', this.productShotKey);
      }
      this.$store.commit('toggleModalGlobalState', {
        modalName: 'confirmationPhoto',
      });
    },
  },
};
</script>
